import dayjs from 'dayjs';
import React from 'react';
import { stateOptions } from '../commonStateTaxData';
import { Flex, Text } from '../../components';

const customParseFormat = require('dayjs/plugin/customParseFormat');

dayjs.extend(customParseFormat);

export const step1Questions = [
  {
    id: 'employee_first_name_middle_initial',
    title: 'First name and initial',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'filing_status',
    title: 'Please select your withholding status:',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single with one job, single with multiple jobs, or filing as head of household',
      },
      {
        codeValue: 'married',
        shortName: 'Married filing jointly with one job and your spouse doesn\'t work, or a qualifying widow(er)',
      },
      {
        codeValue: 'married_withhold_at_higher_single_rate',
        shortName: 'Married filing jointly and both people work (or you have multiple jobs), or married filing separately',
      },
    ],
  },
];

export const step1Questions2025 = step1Questions.map((question) => {
  if (question.id === 'filing_status') {
    return {
      ...question,
      options: question.options.map((option) => {
        if (option.codeValue === 'married') {
          return {
            ...option,
            shortName: 'Married filing jointly with one job and your spouse doesn\'t work, or a qualifying surviving spouse with qualifying dependents',
          };
        }
        return option;
      }),
    };
  }
  return question;
});

export const getWorksheetInitialQuestions = (version = '') => {
  const date = dayjs(version, 'MM_DD_YYYY');
  const currentYear = dayjs().year();
  const year = date.isValid() ? date.year() + 1 : currentYear;

  const versionedTitle = `Enter the number of children in your household age 16 or under as of December 31, ${year}. If you have no qualifying children, enter 0.`;

  return [
    {
      id: 'number_of_children',
      title: versionedTitle,
      question_type: 'short_text',
      rules: [
        {
          category: 'regex',
          action: 'match',
          value: '^(0|[1-9][0-9]*)$',
        },
      ],
    },
  ];
};

export const allowanceAndAdditionalAmtQuestions = [
  {
    id: 'total_number_of_allowances',
    title: 'Total number of allowances you are claiming',
    question_type: 'short_text',
    is_required: false,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
  {
    id: 'additional_amount',
    title: 'Additional amount (if any) you need withheld from each paycheck: (Enter whole dollars)',
    question_type: 'short_text',
    is_required: false,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];

export const exemptionQuestion = [
  {
    id: 'exemption_question',
    question_type: 'long_multiple_selection',
    title: 'Exemption from withholding',
    is_required: true,
    options: [
      {
        codeValue: 'exempted',
        shortName: (
          <Flex column>
            <Text>
              Check this box to claim exemption from withholding if
              you meet both of the following conditions:
            </Text>
            <Text>
              {'\u2022'}
              {' '}
              Last year you had no Idaho income tax liability, and
            </Text>
            <Text>
              {'\u2022'}
              {' '}
              This year you expect to have no Idaho income tax liability.
            </Text>
          </Flex>
        ),
      },
    ],
  },
];

export const additionalAmountInitialQuestion = [
  {
    id: 'additional_amount',
    title: 'Additional amount (if any) you need withheld from each paycheck: (Enter whole dollars)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];
